var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"imgRef",style:({ 'object-fit': _vm.isCover ? 'cover' : '' }),attrs:{"src":_vm.imgSrc,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }